export default "__VITE_ASSET__DWOIOaKs__"